const SdsCreateDownloadJob = () =>
  import(
    "../../components/chemtracker/chemtracker_sds/SdsCreateDownloadJob.vue"
  );

const routes = [
  {
    path: "/node/:nodeId([0-9]+)/chemtracker/sds-download",
    component: SdsCreateDownloadJob,
    props: true,
  },
];

export default routes;
